<template>
  <BAutocomplete
    ref="autocomplete"
    v-bind="$attrs"
    item-text="name"
    item-value="id"
    label="Шаблон Веб-формы"
    no-data-text="Шаблон Веб-формы не найден"
    :request="request"
    v-on="$listeners"
  />
</template>

<script>
import { openApiMixin } from './mixins'
import { FormTemplatesApi as Api } from '@/api/resources'
import { Adapter } from '@/store/createCrudModule'

import BAutocomplete from '../BAutocomplete.vue'


export default {
  name: 'BAutocompleteFormTemplate',
  components: {
    BAutocomplete,
  },
  mixins: [
    openApiMixin,
  ],
  created() {
    const api = new Api()
    this.adapter = new Adapter(api)
  },
  methods: {
    request(...args) {
      return this.adapter.getAll(...args)
    },
  },
}
</script>
